const init = () => {
  const iframe = document.getElementById('form-frame');

  console.log('frame function');
  console.log(iframe);

  iframe.addEventListener('load', function () {
    console.log('iframe load');
    const iframeWindow = iframe.contentWindow;
    const iframeDocument = iframeWindow.document;
    const iframeContentHeight = iframeDocument.body.scrollHeight;
    console.log(iframeWindow);
    console.log(iframeDocument);
    console.log(iframeContentHeight);

    iframe.style.height = iframeContentHeight + 'px';
  });
};

export default init;
